export const common = {
  nav: {
    top: '首页',
    profile: '简介',
    contact: '联系我们',
    onlineShop: '在线商店',
    onlineStore: '在线商店',
    wechat: '微信'
  },
  hero: {
    title1: '',
    title2: '北海道',
    title3: '干海参',
    subtitle: '干海参',
    factoryTitle: '小樽工厂'
  },
  intro: {
    heading1: '~来自北海道小樽的最高品质海参~',
    heading2: '用日本工艺精心加工天然恩惠，送往世界各地的餐桌',
    title1: '来自北海道海域',
    title2: '–优质干海参',
    subtitle1: '运用日本工艺精心干燥',
    subtitle2: '将大自然的恩惠送往世界各地的餐桌',
    desc1: '生长在北海道寒冷海域的海参营养价值极高，自古以来就因其滋补强身和美容功效而备受珍视。',
    desc2: '其中，我们只提供最高级的天然"金海参"，在自家工厂精心加工、干燥，确保最高品质。',
    desc3: '生长在北海道寒冷海域的海参',
    desc4: '营养价值极高',
    desc5: '自古以来就作为滋补强身',
    desc6: '和美容食材而备受珍视',
    desc7: '其中我们经营的海参',
    desc8: '是最高级的天然【金海参】',
    desc9: '在自家工厂精心加工、干燥',
    desc10: '保证其品质'
  },
  shop: {
    title: '在线商店',
    comingSoon: '即将推出..',
    button: '前往'
  },
  faq: {
    title: '常见问题',
    subtitle: '常见问题解答',
    q1: 'Q 这是北海道哪里捕获的海参？',
    a1: 'A 我们常年从北海道全域采购，因此产地会根据季节而有所不同。',
    q2: 'Q 可以国际配送吗？',
    a2: 'A 可以。根据配送方式价格会有所不同，详情请咨询。',
    q3: 'Q 为什么北海道海参价格昂贵？',
    a3: 'A 北海道海参与其他地区相比营养价值更高。而且因其刺大而美丽，被称为【黑钻石】。',
    q4: 'Q 有原产地证明和放射性检测证书吗？',
    a4: 'A 有的，但因为是通关用文件，所以只提供给业者。'
  },
  preparation: {
    title: '海参的泡发方法',
    step1Title: '步骤 1',
    step1Desc1: '轻轻清洗海参表面的污垢，浸泡24~36小时。',
    step1Desc2: '每天换水一次。',
    step2Title: '步骤 2',
    step2Desc: '变软后，从腹部的切口处用刀切入，彻底清除残留的内脏和沙子。',
    step3Title: '步骤 3',
    step3Desc: '将清洗干净的海参煮至喜欢的软度。煮约1小时即可达到适中的软度。',
    step4Title: '步骤 4',
    step4Desc: '关火后自然冷却，加入冰块在冰箱中冷藏48~72小时。'
  },
  knowledge: {
    title: '海参小知识💡',
    heading1: '据说海参对滋补强身有益。',
    heading2: '到底对身体有什么好处呢？',
    desc1: '北海道产【黑海参】的主要成分',
    desc2: '是胶原蛋白',
    desc3: '氨基酸含量非常丰富。',
    desc4: '具有造血作用、促进钙吸收、有助于性功能和体力增强，还有恢复疲劳、改善寒性体质、对抗干燥肌肤等众多令人欣喜的功效！',
    desc5: '海参也被称为海中的【人参】，因其营养价值和强壮作用',
    desc6: '自古以来就备受珍视。',
    desc7: '实际上，有贫血倾向的孕妇持续食用我们的海参后数值得到显著改善，膝盖不好的老奶奶身体状况也变好了，我们收到了许多这样令人欣喜的反馈！'
  },
  news: {
    title: '新闻',
    date1: '2025/8/1',
    content1: '网站已更新。'
  },
  footer: {
    copyright: 'Copyright 2025 Miyakoya'
  },
  profile: {
    title: '公司简介',
    companyName: '公司名称',
    companyNameValue: 'Leaders株式会社',
    established: '成立时间',
    establishedValue: '2015年4月1日',
    capital: '注册资本',
    capitalValue: '500万日元',
    ceo: '代表董事',
    ceoValue: '武田敏之',
    address: '总部地址',
    addressValue1: '〒335-0025',
    addressValue2: '埼玉县户田市南町3-27',
    branch: '分支机构',
    branchValue: '北海道 小樽工厂',
    employees: '员工人数',
    employeesValue: '10名(截至2025年8月)',
    business: '业务内容',
    businessValue: '●水产品采购·加工销售·海外出口',
    banks: '合作银行',
    banksValue1: '●三菱UFJ银行涩谷支行',
    banksValue2: '●小樽信用金库',
    history: '公司历程',
    history1Title: '●2015年4月',
    history1Value: '以注册资本500万日元成立Leaders株式会社',
    history2Title: '●2020年',
    history2Value: '注册资本增资至2000万日元',
    history3Title: '●2020年',
    history3Value: '北海道小樽工厂开始加工业务'
  },
  contact: {
    title: '联系我们',
    lastName: '姓',
    firstName: '名',
    companyName: '公司名称',
    post: '部门·职位',
    phone: '电话号码',
    email: '邮箱地址',
    inquiry: '咨询内容',
    required: '必填',
    phonePlaceholder: '080-0000-0000',
    emailPlaceholder: 'xxxx@example.com',
    inquiryPlaceholder: '请输入咨询内容',
    charCount: '字',
    notRobot: '我不是机器人',
    submit: '提交',
    submitting: '提交中...',
    successMessage: '提交成功。感谢您的咨询。',
    errorMessage: '提交失败。请重试。',
    privacyNote: '请阅读使用条款和隐私政策后同意并提交。',
    robotAlert: '请确认您不是机器人。',
    requiredAlert: '请填写必填项。',
    charLimitAlert: '咨询内容请在500字以内输入。'
  },
  wechat: {
    mainTitle: '微信在这里'
  }
};
